import { QRCode } from "antd";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  gap: 1rem;
  padding: 2rem;
  background: transparent;
  border-radius: 12px;
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1.5rem;
    padding: 1.5rem;
  }
`;

export const QRCodeSection = styled.div`
  flex-shrink: 0;
`;

export const QRCodeImage = styled(QRCode)`
  border: none;
  width: 250px;
  height: 250px;
  border-radius: 8px;
  justify-content: start;
  padding: 0;
`;

export const InfoSection = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const StatusList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const StatusItem = styled.div<{
  $active?: boolean;
  $completed?: boolean;
  $expired?: boolean;
}>`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px dashed #E5E7EB;
  color: ${(props) => {
    if (props.$completed) return "#28a745";
    if (props.$expired) return "#fd7e14";
    if (props.$active) return "#6c757d";
    return "#adb5bd";
  }};
  background: ${(props) => {
    if (props.$active || props.$completed || props.$expired) return "#ffffff";
    return "transparent";
  }};
  font-weight: ${(props) =>
    props.$active || props.$completed || props.$expired ? "500" : "400"};
`;

export const StatusIcon = styled.div<{
  $active?: boolean;
  $completed?: boolean;
  $expired?: boolean;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;

  svg {
    width: 16px;
    height: 16px;
  }
`;

export const ConsultLink = styled.button`
  background: none;
  border: none;
  color: #007bff;
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.9rem;
  padding: 0;

  &:hover {
    color: #0056b3;
  }
`;

export const ExpirationSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ExpirationLabel = styled.div`
  font-weight: 600;
  color: #111827;
  font-size: 14px;
`;

export const CountdownTimer = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #6B7280;
`;

export const PixSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const PixCodeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
`;

export const PixCode = styled.div`
  flex: 1;
  font-family: Barlow, "Segoe UI", Roboto, monospace;
  font-size: 0.8rem;
  color: #495057;
  word-break: break-all;
  line-height: 1.4;
`;

export const CopyButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.5rem;
  background: transparent;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;

  svg {
    width: 12px;
    height: 12px;
    stroke: #6B7280;
  }
`;